/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaFilasVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaFilas: React.FunctionComponent<ITablaFilasVistaProps & InjectedIntlProps> = ({
    filass,
    cargarFilas,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={filass}
            actions={acciones(manejarFormulario, cargarFilas, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaFilas);
